export function formatTimeCode(timecode) {

    if (!timecode) {

        return undefined;

    }

    const timeList = timecode.split(':');
    let hr = parseInt(timeList[0]);
    let min = parseInt(timeList[1]);
    let sec = timeList[2];

    if(hr > 9) {

        return timecode;

    } else if(hr < 10 && hr > 0) {

        return `${hr}:${timeList[1]}:${timeList[2]}`;

    }

    if(min <= 0 && hr > 0) {

        min = timeList[1];

    }

    if(hr <= 0) {

        return `${min}:${sec}`;

    } else {

        return timecode;

    }


};
